import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { FormDefinitionBuilder } from "./NodeConfigPanel";

const QuestionsSection = ({
  formDefinition,
  variables,
  title,
  hint,
  onChange,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const CONFIG = t("FORM.CONFIG", { returnObjects: true });
  const STRICT = t("CANVAS_EDITOR.STEP.QUESTIONS.STRICT", {
    returnObjects: true,
  });
  const LIST = t("CANVAS_EDITOR.STEP.QUESTIONS.LIST", { returnObjects: true });
  const listLabels = {
    ...LIST,
    more: (count) => t("CANVAS_EDITOR.STEP.QUESTIONS.LIST.MORE", { count }),
  };

  return (
    <section className="canvas-tab__section canvas-tab__section--tight">
      <div>
        <h3 className="canvas-tab__title">{title}</h3>
        <p className="canvas-tab__hint">{hint}</p>
      </div>
      <FormDefinitionBuilder
        formDefinition={formDefinition}
        variables={variables}
        labels={CONFIG}
        strictLabels={STRICT}
        listLabels={listLabels}
        onChange={onChange}
      />
    </section>
  );
};

QuestionsSection.propTypes = {
  formDefinition: PropTypes.object,
  variables: PropTypes.array,
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

QuestionsSection.defaultProps = {
  formDefinition: null,
  variables: [],
  hint: null,
};

export default QuestionsSection;
